import "@inter-ikea-kompis/component-mini-configuration-summary/lib/components/mini-configuration-summary/MiniConfigurationSummary.js";
import WrappedComponent from "@inter-ikea-kompis/component-mini-configuration-summary/lib/components/mini-configuration-summary/MiniConfigurationSummary.js";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import KompisElementRegistry from '@inter-ikea-kompis/web-component/lib/registry/KompisElementRegistry.js';
class KompisMiniConfigurationSummary extends React.Component {
    constructor() {
        super(...arguments);
        this.customElements = new KompisElementRegistry();
        this.listeners = {};
        this.ref = {
            current: null
        };
    }
    render() {
        return React.createElement(this.customElements.getInternalName("kompis-mini-configuration-summary"), this.getForwardedProps(), this.props.children);
    }
    componentWillUnmount() {
        this.setState({
            element: null
        });
        this.removeAllListeners(this.ref.current);
        this.ref.current = null;
    }
    componentWillMount() {
        this.customElements.define("kompis-mini-configuration-summary", WrappedComponent);
    }
    removeAllListeners(element) {
        for (const eventType in this.listeners) {
            const callback = this.listeners[eventType];
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, callback);
            }
            delete this.listeners[eventType];
        }
    }
    updateEventListener(element, callback, eventType) {
        if (callback !== this.listeners[eventType]) {
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, this.listeners[eventType]);
            }
            this.listeners[eventType] = callback;
            if (typeof callback === 'function') {
                element.addEventListener(eventType, this.listeners[eventType]);
            }
        }
    }
    getForwardedProps() {
        const forwardedProps = {
            ref: this.onRef.bind(this),
            class: this.props.className,
            'data-element-name': "kompis-mini-configuration-summary"
        };
        for (const key in this.props) {
            if (!(key in this['constructor']['propTypes'])) {
                forwardedProps[key] = this.props[key];
            }
        }
        return forwardedProps;
    }
    onRef(element) {
        if (element === null) {
            return;
        }
        if (element !== this.ref.current && this.ref.current !== null) {
            this.removeAllListeners(this.ref.current);
        }
        this.updateAllEventListeners(element, this.props);
        this.updateAllPropValues(element, this.props);
        this.ref.current = element;
    }
    updateAllPropValues(element, props) {
        element.animatedPrice = props.animatedPrice;
        element.buttonLabel = props.buttonLabel;
        element.buttonSize = props.buttonSize;
        element.disableLinks = props.disableLinks;
        element.disabled = props.disabled;
        element.hideButtonIcon = props.hideButtonIcon;
        element.hideWhatsIncludedIcon = props.hideWhatsIncludedIcon;
        element.iconType = props.iconType;
        element.loading = props.loading;
        element.localizedInformation = props.localizedInformation;
        element.settings = props.settings;
        element.shoppingProducts = props.shoppingProducts;
        element.theme = props.theme;
        element.translations = props.translations;
        element.visibleModal = props.visibleModal;
    }
    updateAllEventListeners(element, props) {
        this.updateEventListener(element, props.onModalClose, "modalClose");
        this.updateEventListener(element, props.onModalOpen, "modalOpen");
        this.updateEventListener(element, props.onNext, "next");
        this.updateEventListener(element, props.onOpenWhatsIncluded, "openWhatsIncluded");
    }
}
KompisMiniConfigurationSummary.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    animatedPrice: PropTypes.bool,
    buttonLabel: PropTypes.string,
    buttonSize: PropTypes.string,
    disableLinks: PropTypes.bool,
    disabled: PropTypes.bool,
    hideButtonIcon: PropTypes.bool,
    hideWhatsIncludedIcon: PropTypes.bool,
    iconType: PropTypes.string,
    loading: PropTypes.bool,
    localizedInformation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    settings: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    shoppingProducts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    theme: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    translations: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    visibleModal: PropTypes.string,
    onModalOpen: PropTypes.func,
    onModalClose: PropTypes.func,
    onOpenWhatsIncluded: PropTypes.func,
    onNext: PropTypes.func
};
export default KompisMiniConfigurationSummary;
